import axios from "axios";

export default {
    namespaced: true,

    state: {
        administrativeTerritoriesList: [],
    },

    getters: {
        administrativeTerritoriesList(state) {
            // const territories = [{ id: null, name: "Vieta*" }];
            // return territories.concat(state.administrativeTerritoriesList);
            return state.administrativeTerritoriesList;
        },
        administrativeTerritoriesListForFilter(state) {
            // const territories = [{ id: null, name: "Vieta" }];
            // return territories.concat(state.administrativeTerritoriesList);
            return state.administrativeTerritoriesList;
        },
    },

    mutations: {
        SET_ADMINISTRATIVE_TERRITORIES(state, administrativeTerritories) {
            state.administrativeTerritoriesList = administrativeTerritories;
        },
    },

    actions: {
        async getAdministrativeTerritories({ commit }) {
            await axios
                .get("/api/all-administrative-territories")
                .then((response) => {
                    commit("SET_ADMINISTRATIVE_TERRITORIES", response.data);
                });
        },
    },
};
